import { ProverDatepickerComponent } from 'src/app/components/prover-datepicker/prover-datepicker';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, ModalController, ToastController, IonicModule } from '@ionic/angular';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ConfigProvider } from 'src/app/services/config/config';
import { UserProvider } from 'src/app/services/user/user';
import { ImagePipe } from 'src/app/pipes/image/image';
import { MdaProvider } from 'src/app/services/mda/mda';
import { CommonModule } from '@angular/common';
import { format } from 'date-fns';
import { ProverHorasComponent } from 'src/app/components/prover-horas/prover-horas.component';

@Component({
  selector: 'app-mda-pessoa-add',
  templateUrl: './mda-pessoa-add.page.html',
  styleUrls: ['./mda-pessoa-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    ReactiveFormsModule,
    NomenclaturaPipe,
    ProverDatepickerComponent,
    ProverHorasComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MdaPessoaAddPage implements OnInit {
  pessoa: any = {};
  pessoaInicial: any = {};
  mda: any = { discipuladorBasic: {}, discipuloBasic: {}, created_at: '' };
  mdaVinculo: string = '';
  validations_form: FormGroup;
  tipoVinculoList: any = [
    { 'id': 'DISCIPULO', 'nome': this.translate.instant('Discípulo') },
    { 'id': 'DISCIPULADOR', 'nome': this.translate.instant('Discipulador') }
  ];
  tipoList: any = [];
  edit: boolean = false;
  tipoSelecionado: any = {};
  diaSemanaList: any = [
    { 'id': '1', 'nome': this.translate.instant('Domingo') },
    { 'id': '2', 'nome': this.translate.instant('Segunda-Feira') },
    { 'id': '3', 'nome': this.translate.instant('Terça-Feira') },
    { 'id': '4', 'nome': this.translate.instant('Quarta-Feira') },
    { 'id': '5', 'nome': this.translate.instant('Quinta-Feira') },
    { 'id': '6', 'nome': this.translate.instant('Sexta-Feira') },
    { 'id': '7', 'nome': this.translate.instant('Sábado') }
  ];

  frequenciaDiasList: any = [
    { 'id': '7', 'nome': this.translate.instant('1 Semana') },
    { 'id': '14', 'nome': this.translate.instant('2 Semanas') },
    { 'id': '30', 'nome': this.translate.instant('1 Mês') }
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    public mdaProvider: MdaProvider,
    public toastCtrl: ToastController,
    public userProvider: UserProvider,
    private translate: TranslateService,
    public configProvider: ConfigProvider
  ) {

    this.pessoaInicial = this.navParams.get('pessoa');
    if (this.navParams.get('mda')) {
      this.mda = this.navParams.get('mda');
    }

    this.mdaVinculo = this.navParams.get('mdaVinculo');


    if (this.mda && this.mda.id) {
      this.edit = true;

      if (this.mdaVinculo == 'DISCIPULADOR') {
        this.pessoa = this.mda.discipuladorBasic;
      } else {
        this.pessoa = this.mda.discipuloBasic;
      }

      this.validations_form = this.formBuilder.group({
        data: new FormControl(this.mda.created_at.substring(0, 10), Validators.required),
        vinculo: new FormControl(this.mdaVinculo, Validators.required),
        observacao: new FormControl(this.mda.observacao),
        horarioInicio: new FormControl(this.mda.horarioInicio ? (this.mda.horarioInicio.substr(0, 2) + ':' + this.mda.horarioInicio.substr(2, 2)) : ''),
        diaSemana: new FormControl(this.mda.diaSemana),
        frequenciaDias: new FormControl(this.mda.frequenciaDias),
        idMdaTipo: new FormControl(this.mda.idMdaTipo),
      });

      this.mdaProvider.getEncontroTipo().subscribe((data) => {
        this.tipoList = data;
        this.mudarTipo(this.mda.idMdaTipo, true);
      });

    } else {
      this.mdaProvider.getEncontroTipo().subscribe((data) => {
        this.tipoList = data;
      });

      this.validations_form = this.formBuilder.group({
        data: new FormControl(format(new Date(), 'yyyy-MM-dd'), Validators.required),
        vinculo: new FormControl('', Validators.required),
        observacao: new FormControl(''),
        horarioInicio: new FormControl(null),
        diaSemana: new FormControl(null),
        frequenciaDias: new FormControl(null),
        idMdaTipo: new FormControl(null)
      });
    }

  }

  ngOnInit() { }

  validation_messages = {
    'data': [
      { type: 'required', message: this.translate.instant('A data deve ser informada') }
    ],
    'vinculo': [
      { type: 'required', message: this.translate.instant('O vinculo deve ser informado') }
    ],
    'horarioInicio': [
      { type: 'required', message: this.translate.instant('O horário inicial deve ser informado') }
    ],
    'diaSemana': [
      { type: 'required', message: this.translate.instant('O dia da semana ser informado') }
    ],
    'frequenciaDias': [
      { type: 'required', message: this.translate.instant('A frequencia deve ser informada') }
    ]
  };

  mudarTipo(idMdaTipo: any, type = false) {
    const validation = type ? idMdaTipo : idMdaTipo.detail.value;

    if (validation) {
      this.tipoList.forEach((element: { id: any; }) => {
        if (element.id == validation) {
          this.tipoSelecionado = element;

          if (this.tipoSelecionado.hasHorario == '1') {
            this.mudarRequirido(true);
          } else {
            this.mudarRequirido(false);
          }
        }
      });
    }
  }

  mudarRequirido(requirido: boolean) {
    if (requirido) {
      this.validations_form.get('horarioInicio')?.setValidators([Validators.required]);
      this.validations_form.get('diaSemana')?.setValidators([Validators.required]);
      this.validations_form.get('frequenciaDias')?.setValidators([Validators.required]);
    } else {
      this.validations_form.get('horarioInicio')?.setValidators([]);
      this.validations_form.get('diaSemana')?.setValidators([]);
      this.validations_form.get('frequenciaDias')?.setValidators([]);
      this.validations_form.get('idMdaTipo')?.setValidators([]);
      this.validations_form.get('horarioInicio')?.setValue(null);
      this.validations_form.get('diaSemana')?.setValue(null);
      this.validations_form.get('frequenciaDias')?.setValue(null);
    }

    this.validations_form.controls['horarioInicio'].updateValueAndValidity();
    this.validations_form.controls['diaSemana'].updateValueAndValidity();
    this.validations_form.controls['frequenciaDias'].updateValueAndValidity();

  }

  async selecionarPessoa() {
    const dataPessoa = {
      buscarGeral: true,
      adiciona: true
    };
    const modalPessoa = await this.modalCtrl.create({ component: BuscarPessoaPage, componentProps: dataPessoa });
    modalPessoa.present();

    const pessoa = (await modalPessoa.onWillDismiss());
    if (pessoa.data) {
      this.pessoa = pessoa.data.pessoa;
    }

  }

  onSubmit(mda: any) {
    if (this.edit) {
      mda.id = this.mda.id;
    }
    mda.cadastroRealizado = false;
    mda.pessoaA = this.pessoaInicial;
    mda.pessoaB = this.pessoa;

    this.mdaProvider.salvarVinculo(mda).subscribe(async data => {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant('Vinculo criado com sucesso!'),
        duration: 3000
      });

      toast.present();
      this.modalCtrl.dismiss(data);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
